module.exports = __webpack_public_path__ + "img/profile.8e6af916.png";